import gql from 'graphql-tag';
import { ProductImageAllData } from '../fragments';

export default gql`
mutation adminAddProductImages (
    $product_id: ID!
    $images: [AdminProductImageInput!]!
) {
    adminAddProductImages (input: {
        product_id: $product_id
        images: $images
    }) {
        ...ProductImageAllData
    }
}
${ProductImageAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminAddProductImages.ts